import { AngularFirestore, DocumentReference } from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { Venue } from "../models/venue";
import { map } from "rxjs/operators";
import { CalendarEvent } from "../models";
import { CalendarEventBuilder } from "../builders/calendar-event.builder";
import { Product } from "../product/product";
import { ProductBuilder } from "../product/product.builder";

import * as moment from "moment";
export enum TimeframeSetting {
  Today,
  Yesterday,
  WeekToDate,
  Last7Days,
  LastWeek,
  Last30Days,
  LastMonth,
  MonthToDate,
  YearToDate,
  Last12Months,
  LastCalendarYear,
  AllTime,
  Custom
}

export class VenueApi {
  constructor(public db: AngularFirestore) {}

  getVenuesForCity(path: string): Promise<Venue[]> {
    return this.db
      .doc(path)
      .collection<Venue>("Venues")
      .get()
      .toPromise()
      .then(venueData => {
        return venueData.docs.map(doc => {
          var data = doc.data();
          var id = doc.id;
          return new Venue(data, id);
        });
      });
  }
  async countActivePasses(venue: Venue) {
    var count = 0;
    await venue.city
      .collection("Venues")
      .doc(venue.id)
      .collection("Products")
      .where("is_active", "==", true)
      .get()
      .then(result => {
        count = result.docs.length;
      });
    return count;
  }
  async get(path: string): Promise<Venue> {
    let v = await this.db
      .doc<Venue>(path)
      .snapshotChanges()
      .pipe(
        map(venue => {
          var data = venue.payload.data();
          const id = venue.payload.id;
          return new Venue(data, id);
        })
      )
      .toPromise();
    return v;
  }

  getAll(): Observable<Venue[]> {
    return this.db
      .collectionGroup<Venue>("Venues")
      .snapshotChanges()
      .pipe(
        map(venues => {
          return venues.map(venue => {
            var data = venue.payload.doc.data();
            const id = venue.payload.doc.id;
            return new Venue(data, id);
          });
        })
      );
  }

  async update(data: Venue): Promise<void> {
    await data.city
      .collection("Venues")
      .doc(data.id)
      .update(data);
  }

  getProducts(venue: Venue): Observable<Product[]> {
    const venueReference = this.db.doc(venue.path).ref;
    return (
      this.db
        // .collectionGroup("Products")
        .doc(venue.path)
        .collection("Products")
        .snapshotChanges()
        .pipe(
          map(products => {
            /*************TO WIPE PRODUCTS *************/
            // console.log(products.length);
            // let x = products.map(product => {
            //   var data = product.payload.doc.data();
            //   const id = product.payload.doc.id;
            //   const path = product.payload.doc.ref.path;
            //   console.log(path);
            //   product.payload.doc.ref.delete();
            //   this.getEvents(path).subscribe(events => {});
            // });
            // return [];
            /********************************************/

            return products.map(product => {
              var data = product.payload.doc.data();
              const events$ = this.getEvents(product.payload.doc.ref.path);
              return new ProductBuilder()
                .load(data, product.payload.doc.ref, venueReference)
                .observe(events$)
                .build();
            });
          })
        )
    );
  }

  async updateProduct(product: Product): Promise<void> {
    console.log(product.productType);
    console.log(product.toJSON());
    await product.reference.update(product.toJSON());
    return;
  }
  async addProduct(product: Product): Promise<DocumentReference> {
    if (product.reference != null) {
      await product.reference.update(product.toJSON());
      return product.reference;
    } else {
      let d = await product.venue.collection("Products").add(product.toJSON());
      return d;
    }
  }

  getEvents = (path: string): Observable<CalendarEvent[]> =>
    this.db
      .doc(path)
      .collection("Events", ref => ref.orderBy("date"))
      .snapshotChanges()
      .pipe(
        map(events => {
          return events.map(event => {
            var data = event.payload.doc.data();
            var ref = event.payload.doc.ref;
            return new CalendarEventBuilder().load(data, ref).build();
          });
        })
      );
  async addEventsToProduct(
    ref: DocumentReference,
    events: CalendarEvent[]
  ): Promise<void> {
    var batch = this.db.firestore.batch();
    for (let i = 0; i < events.length; i++) {
      let e: CalendarEvent = events[i];
      let id = moment(e.date).format("MM-DD-YY");
      batch.set(ref.collection("Events").doc(id), e.toJSON());
    }
    return batch.commit();
  }
}
